<template>
  <section>
    <div
      id="announcement"
      class="modal fade"
      tabindex="-1"
      aria-hidden="true"
      data-backdrop="static" 
      data-keyboard="false"
    >
      <div
        class="modal-dialog"
      >
        <div 
          class="modal-content"
        >
          <div class="modal-header bg-primary">
            <h5 class="modal-title">
              <span>
                <i class="fa-solid fa-envelope-open-text mr-1" /> {{ $t("Announcement") }}
              </span>
            </h5>
          </div>
          <div class="modal-body py-0 px-0">
            <div
              class="list-news flex-column"
            >
              <div 
                id="description"
                class="px-4 py-3 over-flow-scroll" 
                @scroll="onScroll"
              >
                <div
                  v-html="announcement[0].description"
                />
              </div>
            </div>
          </div>
          <div class="border-top justify-content-between modal-footer pt-3">
            <div
              class="d-flex flex-row"
            >
              {{ $t("Click “Accept” to agree to the Terms of Service.") }}
            </div>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              style="height: 2.25rem !important;"
              @click="accept(announcement[0].id)"
              :disabled="isDisabled"
            >
              <i class="fa-solid fa-circle-check mr-1" /> {{ $t("_StoreIndex.Accept") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import CentralApi from '@/services/endpoint/central.service'

export default{
  props: {
    announcement: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      isDisabled: true,
    };
  },
  methods: {
    onScroll(e){
      if(e.target.scrollTop + e.target.clientHeight >= $('#description')[0].scrollHeight - 70) {
        this.isDisabled = false;
      }
    },
    accept(announcementId){
      CentralApi.Announcement.acceptAnnouncement(announcementId).then( async function(response) {
        console.log(response.data);
      }).catch((error) => {
        console.log(error);
      })
    },
    checkIsScroll(){
      if($('#description').scrollTop() + $('#description').height() >= $('#description')[0].scrollHeight - 70) {
        this.isDisabled = false;
      }
    },
  },
  mounted(){
    const vm = this
    $('#announcement').on('shown.bs.modal', function (e) {
      vm.checkIsScroll();
    })
  },
};


</script>

<style scoped>
.over-flow-scroll {
  height: 450px;
  overflow-y: scroll;
}
.button-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.btn-page-contain {
  width: 22px;
  height: 22px;
  border-radius: 22px;
  border: 1px solid #a2adb1;
  background-color: transparent !important;
  text-align: center;
  vertical-align: middle;
  line-height: 15px;
}

.btn-page-contain:hover {
  cursor: pointer !important;
}

.btn-page-label {
  font-size: 9px;
  color: #a2adb1;
  vertical-align: middle !important;
}

.btn-page-contain-active {
  width: 22px;
  height: 22px;
  border-radius: 22px;
  border: 1px solid #2196f3;
  background-color: #2196f3 !important;
  text-align: center;
  vertical-align: middle;
  line-height: 15px;
}

.btn-page-label-active {
  font-size: 9px;
  color: #fff;
}

.btn-page-contain-active:hover {
  cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// src/components/central/account/stores/AnnouncementPopup.vue